import { observer } from 'mobx-react-lite'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { AmendmentsCard } from '@/features/jobs/details/components/AmendmentsCard'
import { AmendmentsTableContainer } from '@/features/jobs/details/components/AmendmentsCard/AmendmentsTable/AmendmentsTableContainer'

export interface AmendmentsCardContainerProps {
  vm: JobDetailsViewModel
}

export const AmendmentsCardContainer = observer(
  function AmendmentsCardContainer({ vm }: AmendmentsCardContainerProps) {
    const isTableVisible = vm.actionsVm.hasVisibleAmendments
    return (
      <AmendmentsCard
        canAddAmendment={!vm.completed}
        onAddAmendment={vm.actionsVm.createAmendmentVm.show}
        isTableVisible={isTableVisible}
        table={
          isTableVisible && (
            <AmendmentsTableContainer vm={vm.detailsVm.amendmentsTableVm} />
          )
        }
      />
    )
  },
)
